import { Injectable } from '@angular/core'
import { CollectionPageProperties, SegmentTagV2 } from 'src/app/shared/analytics/models/segment-tag.model'
import { SegmentService } from 'src/app/shared/analytics/services/segment.service'

@Injectable()
export class CollectionAnalyticsService {
  public constructor(private readonly segment: SegmentService) {}

  /**
   * Abstracts the Segment page call for Collection pages.
   * This allows for the page call properties to be typed specifically for Collection pages.
   */
  public sendPageCall(collectionTagProps: SegmentTagV2, collectionPageProperties: CollectionPageProperties): void {
    this.segment.pageV2(collectionTagProps, collectionPageProperties)
  }
}
